/**
 * Whether a click on a bag square is one more tap of a burst that was aimed
 * at something else, which has just run out and let the next pile slide
 * into the square under the finger. Asked about on 2026-10-09: "check what
 * happens if you tap them too quickly, that nothing unexpected happens".
 * Tapping the last two of five health potions as fast as a thumb goes drank
 * the two and then three mana potions, which had moved up into the square
 * before the thumb could see them go. The id sent with every use names
 * what the client drew, so the server did as it was told.
 *
 * So a click on the square the last one used, within BURST_MS of it, on a
 * different thing, is the end of the old burst rather than the start of a
 * new one, and does nothing. Each swallowed tap keeps the burst going, so a
 * thumb still hammering is still ignored; a pause, or a tap on another
 * square, and the new pile is used as it always was.
 *
 * Kept apart from ui.ts, on nothing but numbers, so the rule can be run
 * under node without a page.
 */
export const BURST_MS = 500;

export class TapBurst {
  private slot = -1;
  private id = 0;
  private owner = "";
  private at = -Infinity;

  /**
   * Reports whether the click should be swallowed, and remembers it as the
   * last use when it should not.
   */
  slidIn(slot: number, id: number, owner: string, now: number): boolean {
    if (slot === this.slot && now - this.at < BURST_MS && (id !== this.id || owner !== this.owner)) {
      this.at = now;
      return true;
    }
    this.slot = slot;
    this.id = id;
    this.owner = owner;
    this.at = now;
    return false;
  }
}
